var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * InterfaceFolder component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconInterfaceFolder extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.00987 3.57103C2.58957 2.99132 3.37582 2.66565 4.19565 2.66565H9.75198C10.0404 2.66565 10.3033 2.83106 10.4281 3.0911L12.4714 7.34796H19.8033C20.6232 7.34796 21.4094 7.67363 21.9891 8.25333C22.5688 8.83304 22.8945 9.61929 22.8945 10.4391V18.243C22.8945 19.0628 22.5688 19.849 21.9891 20.4287C21.4094 21.0084 20.6232 21.3341 19.8033 21.3341H4.19565C3.37582 21.3341 2.58957 21.0084 2.00987 20.4287C1.43017 19.849 1.10449 19.0628 1.10449 18.243V5.7568C1.10449 4.93698 1.43017 4.15073 2.00987 3.57103ZM4.19565 4.16565C3.77365 4.16565 3.36893 4.33329 3.07053 4.63169C2.77213 4.93009 2.60449 5.3348 2.60449 5.7568V18.243C2.60449 18.665 2.77213 19.0697 3.07053 19.3681C3.36893 19.6665 3.77365 19.8341 4.19565 19.8341H19.8033C20.2253 19.8341 20.6301 19.6665 20.9285 19.3681C21.2269 19.0697 21.3945 18.665 21.3945 18.243V10.4391C21.3945 10.0171 21.2269 9.61239 20.9285 9.31399C20.6301 9.0156 20.2253 8.84796 19.8033 8.84796H11.9995C11.7111 8.84796 11.4482 8.68254 11.3233 8.42251L9.28006 4.16565H4.19565Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconInterfaceFolder.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconInterfaceFolder.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconInterfaceFolder.prototype, "size", void 0);
if (customElements.get('cat-icon-interface-folder') === undefined) {
    customElements.define('cat-icon-interface-folder', BlocksIconInterfaceFolder);
}
